import React, { useContext, useState } from 'react';
import DeletionContext from 'src/MultiDeletionFunctionality/@state/DeletionStateContext';
import DELETE_ACTIONS from 'src/MultiDeletionFunctionality/@state_manager/actions';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import {
  Actions,
  WarningMessageModal,
  Tabs,
  BorderGradient,
  IconWithText,
  Helper,
  Button,
} from 'Components';
import history from 'src/history';
import './SuppliesDesktopHeader.css';

const SuppliesDesktopHeader = ({
  tabs,
  tabIndex,
  pageSize,
  onTabsClick,
  onPageSizeChange,
  isSupplyWarningON,
  isPrepaid,
  setAppState
}) => {
  const { deletionState, dispatch } = useContext(DeletionContext);
  const [isWarningMessageOpen, setOpenWarningMessage] = useState(false);

  const handleProceed = () => {
    history.push('/supplies/new');
    setOpenWarningMessage(false);
  };
  const handleCancle = () => {
    setOpenWarningMessage(false);
  };
  const handlOnClick = () => {
    if (isPrepaid) {
      setAppState({ isPrepaidOrder: true });
      history.push('/submissions/new');
    }
    else {
      if (isSupplyWarningON === 'ON') {
        setOpenWarningMessage(true);
      } else {
        history.push('/supplies/new');
      }
    }
   
  };
  return (
    <div className="supplies-desktop-header">
      <div className="supplies-desktop-header__bar">
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '10px',
          }}
        >
          <Helper text={i18n.t('tutorials:supplies.newOrder')}>
            <IconWithText
              onClick={handlOnClick}
              icon="add_circle"
              text={i18n.t('orders:NewOrder')}
              textOrientation="before"
            />
          </Helper>

          {/* // ! Disabling the delete button when the selectedItems is empty: */}
          {deletionState.isDeletionModeActive ? (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '10px',
              }}
            >
              <Button
                className="button button--primary"
                onClick={() => {
                  dispatch({
                    type: DELETE_ACTIONS.ACTIVATE_DELETE_CONFIRMATION,
                  });
                }}
                disabled={!(deletionState.selectedItems.length > 0)}
              >
                <span>{i18n.t('common:Delete')}</span>
              </Button>
              <Button
                className="button button--primary"
                onClick={() =>
                  dispatch({ type: DELETE_ACTIONS.DEACTIVATE_DELETION_MODE })
                }
              >
                <span>{i18n.t('common:Cancel')}</span>
              </Button>
            </div>
          ) : null}
        </div>
      </div>

      <BorderGradient />

      <div className="supplies-desktop-header__tabs">
        <Helper text={i18n.t('tutorials:supplies.tabs')}>
          <Tabs
            onClick={onTabsClick}
            tabs={tabs}
            labels={tabs.map((tab) => i18n.t(`orders:${tab}`))}
            index={tabIndex}
            className="tabs__button"
          />
        </Helper>
        <div className="supplies-desktop-header__tabs__actions">
          <Helper
            placement="bottom-left"
            text={i18n.t('tutorials:common.PageSize')}
          >
            <Actions.ResultsPerPage
              value={pageSize}
              onChange={onPageSizeChange}
            />
          </Helper>
        </div>
      </div>
      <div>
        {isWarningMessageOpen && (
          <WarningMessageModal
            onProceed={handleProceed}
            onCancel={handleCancle}
            section="Supply"
          />
        )}
      </div>
    </div>
  );
};

SuppliesDesktopHeader.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.string),
  tabIndex: PropTypes.number,
  pageSize: PropTypes.arrayOf(PropTypes.number),
  onTabsClick: PropTypes.func,
  onPageSizeChange: PropTypes.func,
  isSupplyWarningON: PropTypes.bool,
};

export default SuppliesDesktopHeader;



// WEBPACK FOOTER //
// ./src/containers/Supplies/SuppliesDesktop/SuppliesDesktopHeader/SuppliesDesktopHeader.jsx